const currencySymbols = {
  GBP: '£',
  USD: '$',
  EUR: '€'
};

export default currencySymbols;
